// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"588":"1215b32a","593":"1215b32a","797":"0c772af6"}[chunkId] + ".chunk.css";
};